import api from '@/api/API';
import { PricePlan } from '@/types';

// eslint-disable-next-line import/prefer-default-export
export function add(
  numReports: number, amount: number,
  name: string|null, description: string|null,
): Promise<PricePlan> {
  return api
    .post('/price-plans', {
      numReports,
      amount,
    }).then();
}

export function edit(
  id: string, numReports: number, amount: number,
  name: string|null, description: string|null,
): Promise<void> {
  return api
    .put(`/price-plans/${id}`, {
      numReports,
      amount,
    }).then(response => response.data);
}
